import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import RelatedProductSlider from "../../wrappers/product/RelatedProductSlider";
import ProductDescriptionTab from "../../wrappers/product/ProductDescriptionTab";
import ProductImageDescription from "../../wrappers/product/ProductImageDescription";
import { useEffect, useState } from "react";
import { getMedicamentos } from "../../firebase/firebase-methods";
import { Spinner } from "react-bootstrap";
import { arrSeo } from "../../data/title_seo";
const Product = () => {
  let { pathname } = useLocation();
  let { id } = useParams();
  const { products } = useSelector((state) => state.product);
  let product = products.find(product => product.kinf2 === id);
  const [loading, setLoading] = useState(true);
  const [productoObtenido, setProductoObtenido] = useState({});
  const [objSeo, setObjSeo] = useState({
    kinf2: '',
    title: '',
    description: ''
  });

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      //console.log(id)
      //console.log(product)
      //console.log(pathname)
      if (product) {
        //console.log(product)
        setProductoObtenido(product)

      } else {
        //no se obtiene producto
       // console.log("sin producto")
        const productos = await getMedicamentos()
       // console.log(productos[0])
        let producto = productos.find(producto => producto.kinf2 === id)
        setProductoObtenido(producto)
      }
      setLoading(false)
    }

    const ArrSeoFiltrado = arrSeo.filter(seo => seo.kinf2 === id)
    if (ArrSeoFiltrado.length > 0) {
      setObjSeo(ArrSeoFiltrado[0])
    }

    getData()
    return;
  }, [id]);


  return (
    <Fragment>
      {
        objSeo.name === '' ?
          null :
          <SEO
            title={objSeo.title}
            titleTemplate={"Farmacia Online - Liga Chilena contra la Epilepsia"}
            description={objSeo.description}
          />
      }


      <LayoutOne headerTop="visible">
        {/* breadcrumb */}
        <Breadcrumb
          pages={[
            { label: "Home", path: process.env.PUBLIC_URL + "/" },
            { label: "Medicamentos", path: process.env.PUBLIC_URL + "/medicamentos" },
            { label: productoObtenido.nombre_medicamento, path: process.env.PUBLIC_URL + pathname }
          ]}
        />
        {
          loading ?
            <div className="container pt-120 pb-120">
              <div className="d-flex" style={{ justifyContent: "center" }}>
                <Spinner />
                <p className="pl-10">{"Obteniendo información"}</p>
              </div>

            </div>



            :

            <ProductImageDescription
              spaceTopClass="pt-100"
              spaceBottomClass="pb-100"
              product={productoObtenido}
            />
        }

        {/* product description with image */}


        {/* product description tab */}
        {/* <ProductDescriptionTab
          spaceBottomClass="pb-90"
          productFullDesc={product.descripcion}
        /> */}

        {/* related product slider */}
        {/* <RelatedProductSlider
          spaceBottomClass="pb-95"
          category={product.category[0]}
        /> */}
      </LayoutOne>
    </Fragment>
  );
};

export default Product;
